// Built-in, self-synthesized royalty-free loops (served from /public/music).
export const STORY_MUSIC = [
  { key: "lofi", title: "Lofi Chill", url: "/music/lofi.wav" },
  { key: "uplift", title: "Uplifting", url: "/music/uplift.wav" },
  { key: "happy", title: "Happy Pop", url: "/music/happy.wav" },
  { key: "cinematic", title: "Cinematic", url: "/music/cinematic.wav" },
  { key: "ambient", title: "Ambient", url: "/music/ambient.wav" },
];
